"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Controls = _interopRequireDefault(require("./Controls"));

var _NotAvailable = _interopRequireDefault(require("./NotAvailable"));

var _Loading = _interopRequireDefault(require("./Loading"));

var _panzoom = _interopRequireDefault(require("@panzoom/panzoom"));

var _previewTypesRegister;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ZoomImage = function ZoomImage(_ref) {
  var width = _ref.width,
      height = _ref.height,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["width", "height"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      update = _useState2[0],
      setUpdate = _useState2[1];

  var rootRef = (0, _react.useRef)();
  var imageRef = (0, _react.useRef)();
  var panzoomRef = (0, _react.useRef)();
  var forceUpdate = (0, _react.useCallback)(function () {
    return setUpdate(function (value) {
      return !value;
    });
  }, []);
  var handleZoomIn = (0, _react.useCallback)(function () {
    panzoomRef.current.zoomIn();
    forceUpdate();
  }, []);
  var handleZoomOut = (0, _react.useCallback)(function () {
    panzoomRef.current.zoomOut();
    forceUpdate();
  }, []);
  var handleZoomReset = (0, _react.useCallback)(function () {
    panzoomRef.current.reset();
    forceUpdate();
  }, []);
  var handleWheel = (0, _react.useCallback)(function (event) {
    panzoomRef.current.zoomWithWheel(event);
    forceUpdate();
  }, []);
  var scale = (0, _react.useMemo)(function () {
    if (!panzoomRef.current) return 0;
    return panzoomRef.current.getScale();
  }, [update]);
  (0, _react.useEffect)(function () {
    panzoomRef.current = (0, _panzoom["default"])(imageRef.current, {
      minScale: 1,
      maxScale: 8,
      contain: 'outside'
    });
    rootRef.current.style.overflow = 'visible';
    rootRef.current.addEventListener('wheel', handleWheel);
    return function () {
      panzoomRef.current.destroy();
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full  inline-flex justify-center",
    ref: rootRef,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({}, rest, {
    className: "object-contain max-h-full",
    ref: imageRef
  }))), /*#__PURE__*/_react["default"].createElement(_Controls["default"], {
    disabledZoomReset: scale <= 1,
    disabledZoomIn: scale >= 8,
    disabledZoomOut: scale <= 1,
    onZoomIn: handleZoomIn,
    onZoomOut: handleZoomOut,
    onZoomReset: handleZoomReset
  }));
};

var NormalImage = function NormalImage(props) {
  return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({}, props, {
    className: "object-contain max-h-full"
  }));
};

var previewTypes = {
  zoom: 'zoom',
  normal: 'normal'
};
var previewTypesRegisters = (_previewTypesRegister = {}, (0, _defineProperty2["default"])(_previewTypesRegister, previewTypes.normal, NormalImage), (0, _defineProperty2["default"])(_previewTypesRegister, previewTypes.zoom, ZoomImage), _previewTypesRegister);

var ImagePreview = function ImagePreview(_ref2) {
  var onClose = _ref2.onClose,
      width = _ref2.width,
      height = _ref2.height,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["onClose", "width", "height"]);

  var handleClose = function handleClose(e) {
    onClose && onClose();
  };

  var rootRef = (0, _react.useRef)();

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      type = _useState4[0],
      setType = _useState4[1];

  (0, _react.useEffect)(function () {
    var root = rootRef.current;
    var rootWidth = root.offsetWidth;
    var rootHeight = root.offsetHeight;
    var style = window.getComputedStyle(root);
    var realWidth = rootWidth - parseInt(style.paddingLeft) - parseInt(style.paddingRight);
    var realHeight = rootHeight - parseInt(style.paddingTop) - parseInt(style.paddingBottom);

    if (realWidth > width && realHeight > height) {
      setType(previewTypes.normal);
    } else {
      setType(previewTypes.zoom);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center p-10 ",
    onClick: handleClose,
    style: {
      minHeight: 300,
      height: 'calc(100vh - 80px)'
    },
    ref: rootRef
  }, type ? /*#__PURE__*/_react["default"].createElement(previewTypesRegisters[type], _objectSpread(_objectSpread({}, rest), {}, {
    width: width,
    height: height
  })) : null);
};

var _default = function _default(_ref3) {
  var src = _ref3.src,
      rest = (0, _objectWithoutProperties2["default"])(_ref3, ["src"]);

  var _useState5 = (0, _react.useState)(-1),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      status = _useState6[0],
      setStatus = _useState6[1];

  var widthRef = (0, _react.useRef)(0);
  var heightRef = (0, _react.useRef)(0);
  (0, _react.useEffect)(function () {
    var image = new Image();

    image.onerror = function () {
      return setStatus(0);
    };

    image.onload = function () {
      widthRef.current = image.width;
      heightRef.current = image.height;
      setStatus(1);
    };

    image.src = src;
  }, [src]);
  if (status === -1) return /*#__PURE__*/_react["default"].createElement(_Loading["default"], rest);
  if (status === 0) return /*#__PURE__*/_react["default"].createElement(_NotAvailable["default"], rest);
  return /*#__PURE__*/_react["default"].createElement(ImagePreview, (0, _extends2["default"])({
    src: src,
    width: widthRef.current,
    height: heightRef.current
  }, rest));
};

exports["default"] = _default;
//# sourceMappingURL=Image.js.map